import ApiService from "../ApiService";
import {postRequest} from "../../base/ApiService";
import {steps} from "../constants/createProcessSteps"
import {getCookie} from "../../base/utils";

function getDefaultState() {
    return {
        steps: startingSteps(),
        processesList: [],
        currentStep: 0,
        showModalCourse: null,
        showModalPlace: null,
        showModalUnit: null,
        loadingDraft: false,
        draftPromise: null,
        publishSuccess: null,
        publishingError: null,
        publishingProcess: null,
        validationErrors: emptyErrors(),
        process: {
            oldName: null,
            oldUnits: [null],
            name: "",
            key: null,
            institutionId: null,
            startDate: new Date(),
            endDate: new Date(),
            bannerType: 'horizontal',
            bannerUrl: '',
            noticeUrl: '',
            privacyPolicyUrl: '',
            consentFormUrl: '',
            description: '',
            additionalInfo: '',
            formId: null,
            published: false,
            paused: false,
            typePayment: true,
            priceSubscription: null,
            messageTypePayment: false,
            withoutTest: false,
            form: {
                fields: [
                    {
                        label: "Nome",
                        type: "ST",
                        placeholder: "",
                        required: true,
                        extraFields: [],
                        locked: true,
                    },
                    {
                        label: "E-mail",
                        type: "ST",
                        placeholder: "Digite seu E-mail",
                        required: true,
                        extraFields: [],
                        extras: ["emailValidation"],
                        locked: true,
                    },
                ],
                rules: {
                    ruleList: [],
                    tieBreakList: []
                }
            },
            processUnits: [{
                key: null,
                selectedUnit: null,
                courseFilter: 0,
                courseSearch: "",
                unitCourses: [],
                guide: null,
                testType: 'O',
                testTimes: [],
            }],
        }
    }
}

function startingSteps() {
    let startingSteps = steps;
    startingSteps.forEach((step) => {
        step.past = false;
    });
    return startingSteps;
}

function emptyProcessUnitErrors() {
    return {
        invalidTestDate: [],
        nullTestDatesPlace: [],
        nullTestDatesEnd: [],
        nullTestDatesDate: [],
        nullTestDuration: [],
        nullTestTemplate: [],
        nullTestDayTime: [],
    }
}

function emptyErrors() {
    return {
        invalidDate: null,
        nullName: null,
        repeatedName: null,
        maximumSizeDescription: null,
        maximumSizeAdditionalInfo: null,
        nullStartDate: null,
        nullEndDate: null,
        nullTypePayment: null,
        nullPriceSubscription: null,
        nullPaymentMethod: null,
        minPriceError: null,
        nullUnit: null,
        nullUnitCourse: null,
        nullnewOption: [],
        nullnewField: [],
        equalnewField: [],
        changedPrice: null,
        changedTestFlag: null,
        processUnitErrors: [emptyProcessUnitErrors()],
        nullCheckAccount: null,
    }
}

function saveDescription(state) {
    const re = /"data:(.*?)"/g;
    let matches = state.process.description.match(re);
    let description = state.process.description;

    return new Promise((resolve) => {
        if (matches) {
            let total = matches.length;
            let original;
            let originals = [];
            matches.forEach((base64Data) => {
                original = base64Data.slice(1, -1);
                originals.push(original);
                postRequest('uploadUserFileS3', {file: original}).then((response) => {
                    let url = response.data.response;
                    description = description.replace(originals[matches.length - total], url);
                }).finally(() => {
                    total--;
                    if (total === 0) {
                        state.process.description = description;
                        resolve();
                    }
                }).catch(() => {
                    state.validationErrors.maximumSizeDescription = true;
                });
            });
        } else {
            state.validationErrors.maximumSizeDescription = false;
            resolve();
        }
    });
}

export const processesState = {
    namespaced: true,
    state: () => ({}),
    mutations: {
        resetState(state) {
            Object.assign(state, getDefaultState());
        },
        setStep(state, step) {
            state.steps[state.currentStep].past = true;
            state.currentStep = step;
        },
        validate(state) {
            state.process.processUnits.forEach((processUnit, index) => {
                if (!state.validationErrors.processUnitErrors[index]) {
                    state.validationErrors.processUnitErrors[index] = emptyProcessUnitErrors()
                }
            });

            let step = state.steps[state.currentStep];
            step.validate(state);

        },
        addEmptyUnit(state) {
            state.process.processUnits.push({
                selectedUnit: null,
                courseFilter: 0,
                courseSearch: "",
                unitCourses: [],
                guide: null,
                testType: 'P',
                testTimes: [{
                    dateList: [],
                    time: new Date(),
                    place: null
                }],
            });
            state.validationErrors.processUnitErrors.push(
                emptyProcessUnitErrors()
            )
        },
        copyUnit(state, processUnit) {
            state.process.processUnits.push({
                selectedUnit: null,
                courseFilter: 0,
                courseSearch: "",
                unitCourses: JSON.parse(JSON.stringify(processUnit.unitCourses)),
                guide: null,
                testType: processUnit.testType,
                testTimes: [{
                    dateList: [],
                    time: new Date(),
                    place: null
                }]
            });
            state.validationErrors.processUnitErrors.push(
                emptyProcessUnitErrors()
            )
        },
        deleteUnit(state, index) {
            state.process.processUnits.splice(index, 1);
            state.validationErrors.processUnitErrors.splice(index, 1);
        },
        saveDraft(state) {
            let processUnitDraft;

            state.loadingDraft = true;
            let draft = {
                "token": getCookie('sgpToken'),
                "key": state.process.key,
                "institution_id": state.process.institutionId,
                "banner_url": state.process.bannerUrl,
                "banner_type": state.process.bannerType,
                "notice_url": state.process.noticeUrl,
                "privacyPolicyUrl": state.process.privacyPolicyUrl,
                "consentFormUrl": state.process.consentFormUrl,
                "description": state.process.description,
                "additionalInfo": state.process.additionalInfo,
                "name": state.process.name,
                "start_date": state.process.startDate,
                "end_date": state.process.endDate,
                "form": state.process.form,
                "form_id": state.process.formId,
                "published": state.process.published,
                "paused": state.process.paused,
                "process_units": [],
                "type_payment": state.process.typePayment,
                "payment_method": state.process.paymentMethod,
                "price_subscription": state.process.priceSubscription,
                "withoutTest": state.process.withoutTest,
            };


            state.process.processUnits.forEach((processUnit) => {
                processUnitDraft = {
                    'key': processUnit.key,
                    'unit_id': processUnit.selectedUnit ? processUnit.selectedUnit.id : null,
                    'event_type': processUnit.testType,
                    'test_dates': [],
                    'courses': []
                };

                if (processUnit.unitCourses) {
                    processUnit.unitCourses.forEach((course) => {
                        let course_data = {
                            'name': course.name,
                            'id': course.id,
                            'day_time': course.dayTime,
                            'capacity': course.capacity,
                            'test_template_id': course.testTemplateId
                        };

                        processUnitDraft.courses.push(course_data)
                    });
                }

                let testDate;

                if (processUnit.testTimes) {
                    processUnit.testTimes.forEach((testTime) => {
                        testTime.dateList.forEach((date) => {
                            testDate = date;
                            processUnitDraft.test_dates.push({
                                'date': testDate,
                                'place': testTime.place,
                                'duration': testTime.duration,
                                'end_date': testTime.endDate,
                            });
                        });
                    });
                }

                draft.process_units.push(processUnitDraft);
            });
            state.draftPromise = ApiService.saveSelectionProcessDraft(draft).then((response) => {
                if (!state.process.key) {
                    state.processesList.push({name: state.process.name, key: response.data.key});
                }

                state.process.key = response.data.key;
                state.process.institutionId = response.data.institution_id;
                state.process.formId = response.data.form_id;
                let processUnitList = response.data.process_units;
                processUnitList.forEach((processUnit, index) => {
                    state.process.processUnits[index].key = processUnit.key
                });

                if (response.data.has_subscriptions) {
                    state.process.hasSubscriptions = true;
                }
            }).finally(() => {
                state.loadingDraft = false;
                state.draftPromise = null;
            });

        },
        resetErrors(state) {
            state.validationErrors = emptyErrors();
            state.validationErrors.processUnitErrors = state.process.processUnits.map(() => emptyProcessUnitErrors())
        }
    },
    actions: {
        setStep({state, commit, dispatch}, step) {
            window.scrollTo(0, 0);
            commit('validate');
            commit('setStep', step);
            if (!state.loadingDraft) {
                dispatch('saveDraft');
            }
        },
        saveDraft({state, commit}) {
            if (!state.process.name) {
                return
            }

            state.loadingDraft = true;
            state.validationErrors.changedPrice = false;
            state.validationErrors.changedTestFlag = false;

            if (state.process.published) {
                let hasError = false;
                let currentStep = state.currentStep;
                state.steps.forEach((step, index) => {
                    state.currentStep = index;
                    commit('validate')
                });
                state.currentStep = currentStep;

                state.steps.forEach((step) => {
                    if (!step.valid) {
                        state.publishingError = true;
                        hasError = true;
                    }
                });
                if (hasError) {
                    state.loadingDraft = false;
                    return
                }
            }

            state.draftPromise = new Promise((resolve) => {
                saveDescription(state).then(() => {
                    commit('saveDraft');

                    if (state.process.published) {
                        state.draftPromise.then(() => {
                            resolve();
                        }).catch((error) => {
                            if (error.response) {
                                if (error.response.status === 400) {
                                    state.publishingError = true;
                                    if (error.response.data === 'price_changed') {
                                        state.validationErrors.changedPrice = true;
                                        state.steps[0].valid = false;
                                    } else if (error.response.data === 'without_test_changed') {
                                        state.validationErrors.changedTestFlag = true;
                                        state.steps[0].valid = false;
                                    } else {
                                        state.validationErrors.repeatedName = true;
                                        state.processesList.push({name: state.process.name, key: 'fakeKey'})
                                    }
                                }
                            }
                            resolve();
                        });
                    } else {
                        state.draftPromise.finally(resolve);
                    }
                });
            });

        },
        publish({state, dispatch, commit}) {
            state.publishingProcess = true;
            let invalidStep = false;
            dispatch('saveDraft');

            let currentStep = state.currentStep;

            state.steps.forEach((step, index) => {
                state.currentStep = index;
                commit('validate')
            });

            state.currentStep = currentStep;

            state.steps.forEach((step) => {
                if (!step.valid) {
                    invalidStep = true;
                }
            });

            if (!invalidStep) {

                state.draftPromise.then(() => {
                    ApiService.publishSelectionProcess(state.process.key, {"token": getCookie('sgpToken')}).then(() => {
                        state.process.published = true;
                        state.publishSuccess = true;
                    }).catch((error) => {
                        if (error.response.status === 400) {
                            if (error.response.data === 'criar_conta') {
                                state.validationErrors.nullCheckAccount = true;
                            }
                        }
                        state.publishingError = true;
                        state.publishingProcess = false;
                    });
                }).catch((error) => {
                    if (error.response.status === 400) {
                        state.publishingError = true;
                        if (error.response.data === 'price_changed') {
                            state.validationErrors.changedPrice = true;
                        } else if (error.response.data === 'without_test_changed') {
                            state.validationErrors.changedTestFlag = true;
                        } else {
                            state.validationErrors.repeatedName = true;
                            state.processesList.push({name: state.process.name, key: 'fakeKey'})
                        }
                    }
                });
            } else {

                state.draftPromise.finally(() => {
                    state.publishingProcess = false;
                    state.publishingError = true;
                });
            }
        }
    }
};